
import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import authorization from './authorization'
import globalSettings from './global-settings'
import counselingSession from './counseling-session'
import setup from './setup'


export default combineReducers({
  authorization,
  counselingSession,
  globalSettings,
  setup,
  routerReducer
})


// WEBPACK FOOTER //
// ./src/reducers/index.js